$(document).ready(function () {
	$('.desktop-nav li').on('click', function () {
		$(this).addClass('active').siblings('li').removeClass('active');
	});

	$('.menu-hamburger').on('click', function () {
		$(this).hide();
		$('.menu').show();
	});

	$('.menu-close').on('click', function () {
		$('.menu').hide();
		$('.menu-hamburger').show();
	});

	$('.tabs li').on('click', function () {
		const tabId = $(this).data('tab');

		$('.tabs li').removeClass('active');
		$(this).addClass('active');

		$('.tab').removeClass('active').hide();
		$(tabId).addClass('active').show();

		setTimeout(() => {
			$(tabId)
				.find('.ride__slider')
				.each(function () {
					makeRideSlider($(this));
				});
		}, 0);
		setTimeout(() => {
			$(tabId)
				.find('.research__slider')
				.each(function () {
					makeRideSlider($(this));
				});
		}, 0);
	});

	function animateCount($el) {
		const target = parseInt($el.data('to'), 10) || 0;
		const duration = 2000;

		$({ count: 0 }).animate(
			{ count: target },
			{
				duration,
				easing: 'swing',
				step: function (now) {
					$el.text(Math.floor(now));
				},
				complete: function () {
					$el.text(target);
				},
			},
		);
	}

	function isInViewport(el) {
		const rect = el.getBoundingClientRect();
		return rect.top < window.innerHeight && rect.bottom >= 0;
	}

	function checkCounters() {
		$('.counter').each(function () {
			const $el = $(this);
			if (!$el.data('started') && isInViewport(this)) {
				$el.data('started', true);
				animateCount($el);
			}
		});
	}

	$(window).on('scroll resize load', checkCounters);
	checkCounters();

	$('.reference__slider').bxSlider({
		pager: false,
		infiniteLoop: true,
		minSlides: 1,
		auto: true,
		maxSlides: 2,
		moveSlides: 1,
		slideWidth: 444,
		slideMargin: 12,
		pause: 3500,
		hideControlOnEnd: true,
		nextText: '<img src="images/angle-blue.svg" width="60" height="60"/>',
		prevText: '<img class="rotate-me" src="images/angle-blue.svg" width="60" height="60"/>',
	});

	function makeRideSlider($el) {
		if ($el.data('bx-instance')) {
			$el.data('bx-instance').reloadSlider();
			return;
		}
		const slider = $el.bxSlider({
			pager: false,
			infiniteLoop: true,
			minSlides: 1,
			maxSlides: 1,
			moveSlides: 1,
			nextText: '<img src="images/angle-blue.svg" width="60" height="60"/>',
			prevText: '<img class="rotate-me" src="images/angle-blue.svg" width="60" height="60"/>',
		});
		$el.data('bx-instance', slider);
	}

	$('#tab1 .ride__slider').each(function () {
		makeRideSlider($(this));
	});

	$('#tab1 .reserach__slider').each(function () {
		makeRideSlider($(this));
	});

	document.querySelectorAll('.toggle-password').forEach((button) => {
		button.addEventListener('click', () => {
			const input = button.previousElementSibling;
			const icon = button.querySelector('i');
			const isPassword = input.type === 'password';

			input.type = isPassword ? 'text' : 'password';
			icon.classList.toggle('show', !isPassword);
			icon.classList.toggle('hide', isPassword);
		});
	});
});
